var React = require('react');

function AttachmentSquare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.52864 8.4709L9.64997 6.34957C10.04 5.95957 10.674 5.95957 11.064 6.34957V6.34957C11.454 6.73957 11.454 7.37357 11.064 7.76357L8.47131 10.3562C7.68997 11.1376 6.42397 11.1376 5.64264 10.3562V10.3562C4.86131 9.5749 4.86131 8.3089 5.64264 7.52757L7.99997 5.1709","stroke":"#929088","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 14H4C2.89533 14 2 13.1047 2 12V4C2 2.89533 2.89533 2 4 2H12C13.1047 2 14 2.89533 14 4V12C14 13.1047 13.1047 14 12 14Z","stroke":"#929088","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

AttachmentSquare.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = AttachmentSquare;

AttachmentSquare.default = AttachmentSquare;
